var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 57,
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.044 53.1788H9.92247C7.73199 53.1788 5.93896 51.3805 5.93896 49.1826V4.80185C5.93896 2.604 7.73199 0.80658 9.92247 0.80658H41.044C43.2353 0.80658 45.0284 2.604 45.0284 4.80185V49.1826C45.0284 51.3805 43.2353 53.1788 41.044 53.1788Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3877 55.0763H7.26622C5.07574 55.0763 3.28271 53.278 3.28271 51.0801V6.69938C3.28271 4.50153 5.07574 2.7041 7.26622 2.7041H38.3877C40.5791 2.7041 42.3721 4.50153 42.3721 6.69938V51.0801C42.3721 53.278 40.5791 55.0763 38.3877 55.0763Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8035 56.5743H4.61772C2.42271 56.5743 0.625977 54.7835 0.625977 52.5947V8.39771C0.625977 6.20896 2.42271 4.41898 4.61772 4.41898H35.8035C37.9994 4.41898 39.7962 6.20896 39.7962 8.39771V52.5947C39.7962 54.7835 37.9994 56.5743 35.8035 56.5743Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8035 56.5743H4.61772C2.42271 56.5743 0.625977 54.7835 0.625977 52.5947V8.39771C0.625977 6.20896 2.42271 4.41898 4.61772 4.41898H35.8035C37.9994 4.41898 39.7962 6.20896 39.7962 8.39771V52.5947C39.7962 54.7835 37.9994 56.5743 35.8035 56.5743Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3084 17.8844H8.27392C7.6161 17.8844 7.07764 17.3722 7.07764 16.7463C7.07764 16.1197 7.6161 15.6074 8.27392 15.6074H31.3084C31.9663 15.6074 32.5047 16.1197 32.5047 16.7463C32.5047 17.3722 31.9663 17.8844 31.3084 17.8844Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3084 24.7156H8.27392C7.6161 24.7156 7.07764 24.2033 7.07764 23.5775C7.07764 22.9508 7.6161 22.4386 8.27392 22.4386H31.3084C31.9663 22.4386 32.5047 22.9508 32.5047 23.5775C32.5047 24.2033 31.9663 24.7156 31.3084 24.7156Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3084 31.5468H8.27392C7.6161 31.5468 7.07764 31.0345 7.07764 30.4087C7.07764 29.7828 7.6161 29.2697 8.27392 29.2697H31.3084C31.9663 29.2697 32.5047 29.7828 32.5047 30.4087C32.5047 31.0345 31.9663 31.5468 31.3084 31.5468Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3084 38.3779H8.27392C7.6161 38.3779 7.07764 37.8657 7.07764 37.2398C7.07764 36.6132 7.6161 36.1009 8.27392 36.1009H31.3084C31.9663 36.1009 32.5047 36.6132 32.5047 37.2398C32.5047 37.8657 31.9663 38.3779 31.3084 38.3779Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2976 45.2091H8.27904C7.6184 45.2091 7.07764 44.6968 7.07764 44.071C7.07764 43.4443 7.6184 42.932 8.27904 42.932H20.2976C20.9582 42.932 21.499 43.4443 21.499 44.071C21.499 44.6968 20.9582 45.2091 20.2976 45.2091Z",
    fill: "#E0E2EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.fadb1bdacf015a0104d73f2334546a09.svg";
export { ForwardRef as ReactComponent };